// IELTS Mock 9 — Academic Speaking (advanced difficulty)
// Same shape as IELTS_DATA_SPEAKING in ../IeltsSpeaking.js.
const IELTS_MOCK9_SPEAKING = {
  title: "Academic Speaking Practice Test 9",
  parts: [
    {
      id: "part1",
      title: "Part 1: Introduction & Interview (4-5 min)",
      questions: [
        "Let's talk about sleep. How many hours of sleep do you usually get?",
        "Do you find it easy to sleep in unfamiliar places? Why or why not?",
        "Has your sleeping pattern changed since you were a child?",
        "Let's talk about old buildings. Are there many old buildings where you live?",
        "Would you prefer to live in an old building or a modern one?"
      ]
    },
    {
      id: "part2",
      title: "Part 2: Long Turn (Cue Card) (3-4 min)",
      prompt: "Describe a word or expression from another language that you find interesting. You should say: What the word or expression is, Where you first came across it, What it means, and explain why you find it interesting.",
      preparationTime: 60,
      speakingTime: 120
    },
    {
      id: "part3",
      title: "Part 3: Discussion (4-5 min)",
      questions: [
        "Do you think the language a person speaks affects the way they see the world? Why?",
        "What is lost when a language dies out, and should anything be done to prevent it?",
        "Some people say that translation can never fully capture the meaning of the original. Would you agree?",
        "Why do you think modern societies often undervalue sleep and rest?",
        "Should employers or schools take responsibility for making sure people get enough sleep?",
        "How should a city balance the need for new housing against the wish to preserve its history?"
      ]
    }
  ]
};

export default IELTS_MOCK9_SPEAKING;
